import { FLIPPER_KEYS } from '~/store/flippers/const'
import { FlipperResponseMap } from './types'

export const FLIPPER_RESPONSE_MAP: Partial<FlipperResponseMap> = {
  [FLIPPER_KEYS.XSGD_USE_FIAT_CURRENCY_NAME]: 'isUsingFiatCurrency',
} as const

export enum ACK_TYPES {
  DASHBOARD_REVAMP = 'dashboard_revamp_acknowledged',
  STABLECOIN_TRANSFER_DISCLAIMER = 'stablecoin_transfer_disclaimer_acknowledged',
  DIRECT_MINT_EDUCATIONAL_BANNER = 'direct_mint_educational_banner_acknowledged',
}
